@keyframes banner-shake {
	10%,
	90% {
		transform: translate3d(-1px, 0, 0);
	}

	20%,
	80% {
		transform: translate3d(2px, 0, 0);
	}

	30%,
	50%,
	70% {
		transform: translate3d(-4px, 0, 0);
	}

	40%,
	60% {
		transform: translate3d(4px, 0, 0);
	}
}

.banner {
	--banner-background: var(--color-primary-background);
	--banner-text: var(--color-primary-foreground);

	display: flex;
	align-items: center;
	gap: var(--size-3);
	padding: var(--size-3) var(--size-4);
	background-color: var(--banner-background);
	border-radius: var(--radius-lg);
	color: var(--banner-text);

	&[data-kind="success"] {
		--banner-background: var(--color-success-background);
		--banner-text: var(--color-success-foreground);
	}

	&[data-kind="error"] {
		--banner-background: var(--color-error-background);
		--banner-text: var(--color-error-foreground);
	}

	&[data-kind="warning"] {
		--banner-background: var(--color-warning-background);
		--banner-text: var(--color-warning-foreground);
	}

	@media (prefers-reduced-motion: no-preference) {
		&[data-animate="shake"] {
			animation: banner-shake 1s cubic-bezier(0.36, 0.07, 0.19, 0.97) 0.25s both;
		}
	}
}
